/**
 * IMPORTS
 */

import { ChevronLeft, ChevronRight } from "lucide-react";

// components
import { Button } from "@components/button/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@components/card/card";
import { SearchInput } from "@components/search/search";
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@components/table/table";

// components / pages
import { SearchRequestRow } from "@pages/client/search-requests/components/search-request-row/search-request-row";

function SearchRequestTable({
  products,
  offset,
  totalProducts,
  nextPaginate,
}: {
  products: any[];
  offset: number;
  totalProducts: number;
  nextPaginate(): void;
}) {
  const productsPerPage = 5;

  return (
    <Card>
      <CardHeader className="items-center justify-between">
        <div>
          <CardTitle> Pesquisar solicitações</CardTitle>
          <CardDescription>Gerencie suas solicitações e visualize quando quiser.</CardDescription>
        </div>

        <div>
          <SearchInput />
        </div>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Remessa</TableHead>

              <TableHead>Cliente</TableHead>

              <TableHead className="hidden md:table-cell">Situação</TableHead>

              <TableHead>Solicitante</TableHead>

              <TableHead>Status</TableHead>

              <TableHead>Nº Solicitações</TableHead>

              <TableHead>Tecnologia</TableHead>

              <TableHead>Posição</TableHead>

              <TableHead className="hidden md:table-cell">Data solicitação</TableHead>
              <TableHead className="hidden md:table-cell">Ações</TableHead>
              <TableHead>
                <span className="sr-only">Ações</span>
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {products.map((product) => (
              <SearchRequestRow key={product.id} product={product} />
            ))}
          </TableBody>
        </Table>
      </CardContent>
      <CardFooter>
        <div className="flex w-full items-center justify-between">
          <div className="text-xs text-muted-foreground">
            Mostrando{" "}
            <strong>
              {Math.min(offset - productsPerPage, totalProducts) + 1}-{offset}
            </strong>{" "}
            de <strong>{totalProducts}</strong> baixa de cargas
          </div>
          <div className="flex">
            <Button
              // formAction={prevPage}
              variant="ghost"
              size="sm"
              type="submit"
              disabled={offset === productsPerPage}
            >
              <ChevronLeft className="mr-2 h-4 w-4" />
              Voltar
            </Button>
            <Button
              onClick={nextPaginate}
              variant="ghost"
              size="sm"
              type="submit"
              disabled={offset + productsPerPage > totalProducts}
            >
              Proxímo
              <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </CardFooter>
    </Card>
  );
}

/**
 * EXPORTS
 */
export { SearchRequestTable };
